/* eslint-disable react/prop-types */
import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Tooltip from "@material-ui/core/Tooltip";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import CircularProgress from "@material-ui/core/CircularProgress";
import Datetime from "react-datetime";
import moment from "moment/moment";
import ReactSelect from "react-select";
import { ThreeDots } from "react-loader-spinner";
import {
  Close,
  CheckBox,
  CheckBoxOutlineBlank,
  RadioButtonChecked,
  RadioButtonUnchecked,
  FolderOpen,
  InsertDriveFile,
  DeleteSweep,
  Autorenew,
  Refresh,
  RotateLeftRounded,
  FindReplace,
  LockOpen,
  CheckCircle,
  CloudUpload,
} from "@material-ui/icons";
import Button from "../../../components/CustomButtons/Button";
import ModalHeader from "../../../components/ModalHeader";
import CustomLinearProgress from "../../../components/CustomLinearProgress/CustomLinearProgress";
import useThemeColors from "../../../hooks/useThemeColors";
import {
  grayColor,
  whiteColor,
  dangerColor,
  successColor,
  warningColor,
} from "../../../assets/jss/material-dashboard-pro-react";

export default function SpecialOptionsModal({
  api,
  classes,
  Transition,
  selectStyles,
  userDetails,
  clientColor,
}) {
  const { clientTextColor } = useThemeColors();
  const {
    specialOptionsTab,
    setSpecialOptionsTab,
    specialOptionsStep,
    setSpecialOptionsStep,
    specialOptionsStartMonth,
    setSpecialOptionsStartMonth,
    specialOptionsEndMonth,
    setSpecialOptionsEndMonth,
    specialOptionsProgress,
    specialOptionsStatus,
    specialOptionsError,
    specialOptionsModalOpen,
    specialOptionsSelectedInput,
    setSpecialOptionsSelectedInput,
    specialOptionsSelectedInputs,
    setSpecialOptionsSelectedInputs,
    reprocessInputsList,
    specialOptionsRecalcLogistics,
    setSpecialOptionsRecalcLogistics,
    specialOptionsResetMode,
    setSpecialOptionsResetMode,
    reprocessMode,
    setReprocessMode,
    broadcastFile,
    setBroadcastFile,
    broadcastUploading,
    broadcastFileInputRef,
    lockStatus,
    lockLoading,
    lockReleasing,
    processedPeriodsLoading,
    multiMonthFiles,
    setMultiMonthFiles,
    multiMonthAiMapping,
    setMultiMonthAiMapping,
    multiMonthAiLoading,
    setMultiMonthAiLoading,
    multiMonthUploadProgress,
    multiMonthFolderRef,
    multiMonthFileRef,
    getSpecialOptionsMonthsList,
    handleSelectProcessedPeriods,
    fetchLockStatus,
    handleReleaseLock,
    handleCloseSpecialOptionsModal,
    handleSpecialOptionsConfirm,
    handleSpecialOptionsBack,
    handleSpecialOptionsExecute,
    handleMultiMonthExecute,
    handleMultiMonthConfirmMapping,
    handleCancelBatchJob,
    getSpecialOptionsRangeText,
    isValidMonthRange,
    isValidSpecialOptionsSelection,
    getMonthsInRange,
    activeBatchJob,
    isPollingBatch,
    showUpdateDemoTab,
    t,
    i18n,
  } = api;

  const months = getSpecialOptionsMonthsList();
  const canSelectProcessedPeriods =
    specialOptionsStep === "select" &&
    months.length > 0 &&
    specialOptionsTab !== 4 &&
    (specialOptionsTab === 0 ||
      specialOptionsTab === 1 ||
      (specialOptionsTab === 2 &&
        ((reprocessMode === "existing" &&
          specialOptionsSelectedInputs.length > 0) ||
          (reprocessMode === "broadcast" && specialOptionsSelectedInput) ||
          (reprocessMode === "multi_month" && specialOptionsSelectedInput))));
  const processedPeriodsTooltip =
    specialOptionsTab === 0
      ? t(
          "modeling_inputs_v2.batch_operations.select_processed_periods_tooltip_recalculate",
        )
      : specialOptionsTab === 1
        ? t(
            "modeling_inputs_v2.batch_operations.select_processed_periods_tooltip_reset",
          )
        : t(
            "modeling_inputs_v2.batch_operations.select_processed_periods_tooltip_reprocess",
          );
  const tabLabels = [
    t("modeling_inputs_v2.batch_operations.recalculate"),
    t("modeling_inputs_v2.batch_operations.reset_modeling"),
    t("modeling_inputs_v2.batch_operations.reprocess_input"),
    t("modeling_inputs_v2.batch_operations.remove_lock"),
  ];
  if (showUpdateDemoTab) {
    tabLabels.push(t("modeling_inputs_v2.batch_operations.update_demo"));
  }

  const monthToMoment = (item) =>
    item ? moment({ year: item.year, month: item.month - 1 }) : null;

  const monthsSet = new Set(months.map((m) => m.year * 100 + m.month));

  const isValidMonth = (current) =>
    monthsSet.has(current.year() * 100 + (current.month() + 1));

  const handleMonthChange = (setter) => (date) => {
    if (!moment.isMoment(date)) return;
    const match = months.find(
      (m) => m.year === date.year() && m.month === date.month() + 1,
    );
    if (match) setter(match);
  };

  const dtInputProps = {
    readOnly: true,
    placeholder: t("select"),
    style: {
      width: "100%",
      padding: "8px 10px",
      border: `1px solid ${grayColor[4]}`,
      borderRadius: "4px",
      fontSize: "13px",
      color: grayColor[2],
      cursor: "pointer",
      backgroundColor: whiteColor,
      backgroundImage: "none",
    },
  };

  const monthRangeSelector = (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)",
        gap: "16px",
        alignItems: "flex-start",
        marginTop: "16px",
      }}
    >
      <style>{`
          .specialOptsDt .rdtPicker { z-index: 2100 !important; }
          .specialOptsDt .rdtMonth.rdtActive,
          .specialOptsDt .rdtYear.rdtActive {
            background-color: ${clientColor} !important;
            color: ${clientTextColor} !important;
          }
          .specialOptsDt input.form-control {
            background-image: none !important;
          }
          .specialOptsDt input.form-control:focus {
            background-image: none !important;
            border-color: ${clientColor};
          }
          .specialOptsProcessedBtn {
            margin-left: 0 !important;
            margin-right: 0 !important;
            margin-bottom: 0 !important;
            box-shadow: none !important;
          }
          .specialOptsProcessedBtn:hover,
          .specialOptsProcessedBtn:focus {
            box-shadow: none !important;
          }
        `}</style>
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            marginBottom: "4px",
            fontSize: "12px",
            color: grayColor[0],
          }}
        >
          {t("modeling_inputs_v2.batch_operations.start_month")}
        </div>
        <Datetime
          className="specialOptsDt"
          value={monthToMoment(specialOptionsStartMonth)}
          timeFormat={false}
          closeOnSelect={true}
          dateFormat="YYYY-MM"
          locale={i18n.language}
          onChange={handleMonthChange(setSpecialOptionsStartMonth)}
          isValidDate={isValidMonth}
          inputProps={dtInputProps}
        />
      </div>
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            marginBottom: "4px",
            fontSize: "12px",
            color: grayColor[0],
          }}
        >
          {t("modeling_inputs_v2.batch_operations.end_month")}
        </div>
        <Datetime
          className="specialOptsDt"
          value={monthToMoment(specialOptionsEndMonth)}
          timeFormat={false}
          closeOnSelect={true}
          dateFormat="YYYY-MM"
          locale={i18n.language}
          onChange={handleMonthChange(setSpecialOptionsEndMonth)}
          isValidDate={isValidMonth}
          inputProps={dtInputProps}
        />
      </div>
      <div
        style={{
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            marginBottom: "4px",
            fontSize: "12px",
            lineHeight: 1.33,
            color: grayColor[0],
            opacity: 0,
            userSelect: "none",
            pointerEvents: "none",
          }}
          aria-hidden="true"
        >
          {t("modeling_inputs_v2.batch_operations.start_month")}
        </div>
        <Tooltip title={processedPeriodsTooltip}>
          <span style={{ display: "block", width: "100%" }}>
            <Button
              color="client"
              className="specialOptsProcessedBtn"
              style={{
                width: "100%",
                margin: "6px 0 0 0",
                padding: "8px 10px",
                minHeight: 0,
                boxSizing: "border-box",
                boxShadow: "none",
                textTransform: "none",
                fontSize: "13px",
                fontWeight: 500,
                letterSpacing: "normal",
                lineHeight: 1.3,
                borderRadius: "4px",
                position: "relative",
                display: "block",
                textAlign: "center",
                whiteSpace: "normal",
                minWidth: 0,
              }}
              disabled={!canSelectProcessedPeriods || processedPeriodsLoading}
              onClick={handleSelectProcessedPeriods}
            >
              {processedPeriodsLoading ? (
                <CircularProgress
                  size={12}
                  thickness={5}
                  style={{
                    position: "absolute",
                    left: 10,
                    top: "50%",
                    marginTop: -6,
                  }}
                />
              ) : null}
              <span
                style={{
                  display: "block",
                  width: "100%",
                  textAlign: "center",
                  wordBreak: "break-word",
                }}
              >
                {t(
                  "modeling_inputs_v2.batch_operations.select_processed_periods",
                )}
              </span>
            </Button>
          </span>
        </Tooltip>
      </div>
    </div>
  );

  // Content for each tab
  const renderTabContent = () => {
    if (specialOptionsTab === 4 && specialOptionsStep === "select") {
      return (
        <div style={{ padding: "8px 0" }}>
          <div
            style={{
              fontSize: "14px",
              color: grayColor[0],
              marginBottom: "16px",
              lineHeight: "1.5",
            }}
          >
            {t("modeling_inputs_v2.batch_operations.update_demo_description")}
          </div>
        </div>
      );
    }

    if (specialOptionsTab === 3) {
      return (
        <div style={{ padding: "8px 0" }}>
          <div
            style={{
              fontSize: "14px",
              color: grayColor[0],
              marginBottom: "16px",
              lineHeight: "1.5",
            }}
          >
            {t("modeling_inputs_v2.batch_operations.remove_lock_description")}
          </div>

          {lockLoading && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "16px 0",
              }}
            >
              <CircularProgress size={20} />
            </div>
          )}

          {!lockLoading && lockStatus && lockStatus.locked && (
            <div
              style={{
                padding: "16px",
                backgroundColor: warningColor[6] + "33",
                borderLeft: `4px solid ${warningColor[0]}`,
                borderRadius: "4px",
                marginBottom: "16px",
              }}
            >
              <div style={{ fontSize: "14px", marginBottom: "8px" }}>
                <strong>
                  {t(
                    "modeling_inputs_v2.batch_operations.remove_lock_locked_by",
                  )}
                  :
                </strong>{" "}
                <span style={{ fontFamily: "monospace" }}>
                  {lockStatus.lock_info?.worker_id}
                </span>
              </div>
              <div style={{ fontSize: "14px", marginBottom: "8px" }}>
                <strong>
                  {t(
                    "modeling_inputs_v2.batch_operations.remove_lock_locked_since",
                  )}
                  :
                </strong>{" "}
                {lockStatus.lock_info?.acquired_at
                  ? moment(lockStatus.lock_info.acquired_at).format(
                      "YYYY-MM-DD HH:mm:ss",
                    )
                  : "-"}
              </div>
              <div style={{ fontSize: "14px", marginBottom: "16px" }}>
                <strong>
                  {t(
                    "modeling_inputs_v2.batch_operations.remove_lock_expires_at",
                  )}
                  :
                </strong>{" "}
                {lockStatus.lock_info?.expires_at
                  ? moment(lockStatus.lock_info.expires_at).format(
                      "YYYY-MM-DD HH:mm:ss",
                    )
                  : "-"}
              </div>
              <Button
                color="danger"
                size="sm"
                onClick={handleReleaseLock}
                disabled={lockReleasing}
                style={{ textTransform: "none" }}
              >
                {lockReleasing ? (
                  <CircularProgress
                    size={16}
                    style={{ color: "white", marginRight: "6px" }}
                  />
                ) : (
                  <LockOpen style={{ fontSize: "16px", marginRight: "6px" }} />
                )}
                {t("modeling_inputs_v2.batch_operations.remove_lock_confirm")}
              </Button>
            </div>
          )}

          {!lockLoading && lockStatus && !lockStatus.locked && (
            <div
              style={{
                padding: "16px",
                backgroundColor: successColor[6] + "33",
                borderLeft: `4px solid ${successColor[0]}`,
                borderRadius: "4px",
                fontSize: "14px",
                color: successColor[0],
              }}
            >
              <CheckCircle
                style={{
                  fontSize: "16px",
                  verticalAlign: "middle",
                  marginRight: "6px",
                }}
              />
              {t("modeling_inputs_v2.batch_operations.remove_lock_not_locked")}
            </div>
          )}

          {!lockLoading && !lockStatus && (
            <Button
              color="client"
              size="sm"
              onClick={fetchLockStatus}
              style={{ textTransform: "none" }}
            >
              <Refresh style={{ fontSize: "16px", marginRight: "6px" }} />
              {t("modeling_inputs_v2.batch_operations.remove_lock")}
            </Button>
          )}
        </div>
      );
    }

    if (specialOptionsStep === "ai_matching") {
      const monthsInRange = getMonthsInRange();
      return (
        <div style={{ padding: "16px 0" }}>
          <div style={{ fontWeight: "500", marginBottom: "12px" }}>
            {t("modeling_inputs_v2.batch_operations.multi_month_ai_title")}
          </div>
          {multiMonthAiLoading && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "24px 0",
              }}
            >
              <CircularProgress size={24} />
              <span style={{ fontSize: "14px", color: grayColor[0] }}>
                {t(
                  "modeling_inputs_v2.batch_operations.multi_month_ai_loading",
                )}
              </span>
            </div>
          )}
          {!multiMonthAiLoading && specialOptionsError && (
            <div
              style={{
                padding: "12px",
                backgroundColor: dangerColor[6] + "33",
                borderLeft: "4px solid " + dangerColor[0],
                borderRadius: "4px",
                marginBottom: "12px",
                fontSize: "13px",
                color: dangerColor[0],
              }}
            >
              {specialOptionsError}
            </div>
          )}
          {!multiMonthAiLoading && multiMonthAiMapping.length > 0 && (
            <div style={{ maxHeight: "350px", overflowY: "auto" }}>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontSize: "12px", fontWeight: 600 }}>
                        {t(
                          "modeling_inputs_v2.batch_operations.multi_month_col_file",
                        )}
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: "12px",
                          fontWeight: 600,
                          width: "180px",
                        }}
                      >
                        {t(
                          "modeling_inputs_v2.batch_operations.multi_month_col_month",
                        )}
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: "12px",
                          fontWeight: 600,
                          width: "90px",
                        }}
                        align="center"
                      >
                        {t(
                          "modeling_inputs_v2.batch_operations.multi_month_col_confidence",
                        )}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {multiMonthAiMapping.map((item, idx) => (
                      <TableRow key={idx}>
                        <TableCell
                          style={{
                            fontSize: "12px",
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={item.file.name}
                        >
                          {item.file.name}
                        </TableCell>
                        <TableCell>
                          <ReactSelect
                            options={monthsInRange.map((m) => ({
                              value: m.year + "-" + m.month,
                              label: m.label,
                              monthObj: m,
                            }))}
                            value={
                              item.month
                                ? {
                                    value:
                                      item.month.year + "-" + item.month.month,
                                    label: item.month.label,
                                    monthObj: item.month,
                                  }
                                : null
                            }
                            onChange={(selected) => {
                              setMultiMonthAiMapping((prev) => {
                                const updated = [...prev];
                                updated[idx] = {
                                  ...updated[idx],
                                  month: selected ? selected.monthObj : null,
                                  confidence: selected ? "manual" : "none",
                                };
                                return updated;
                              });
                            }}
                            isClearable
                            placeholder="-"
                            menuPortalTarget={document.body}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: "30px",
                                fontSize: "12px",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                padding: "0 6px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "30px",
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <span
                            style={{
                              fontSize: "11px",
                              padding: "2px 8px",
                              borderRadius: "10px",
                              backgroundColor:
                                item.confidence === "high"
                                  ? "#e8f5e9"
                                  : item.confidence === "medium" ||
                                      item.confidence === "manual"
                                    ? "#fff3e0"
                                    : "#ffebee",
                              color:
                                item.confidence === "high"
                                  ? "#2e7d32"
                                  : item.confidence === "medium" ||
                                      item.confidence === "manual"
                                    ? "#e65100"
                                    : "#c62828",
                            }}
                          >
                            {t(
                              "modeling_inputs_v2.batch_operations.multi_month_confidence_" +
                                item.confidence,
                              item.confidence,
                            )}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
          {!multiMonthAiLoading && multiMonthAiMapping.length > 0 && (
            <div
              style={{
                marginTop: "8px",
                fontSize: "12px",
                color: grayColor[6],
              }}
            >
              {multiMonthAiMapping.filter((i) => i.month).length} /{" "}
              {multiMonthAiMapping.length}{" "}
              {t(
                "modeling_inputs_v2.batch_operations.multi_month_matched_count",
              )}
            </div>
          )}
        </div>
      );
    }

    if (specialOptionsStep === "confirm") {
      if (specialOptionsTab === 4) {
        return (
          <div style={{ padding: "16px 0" }}>
            <div
              style={{
                padding: "16px",
                backgroundColor: grayColor[19] + "66",
                borderRadius: "8px",
                marginBottom: "16px",
              }}
            >
              <div style={{ fontWeight: "500", marginBottom: "8px" }}>
                {t("modeling_inputs_v2.batch_operations.update_demo")}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: grayColor[0],
                  marginBottom: "12px",
                  lineHeight: "1.5",
                }}
              >
                {t(
                  "modeling_inputs_v2.batch_operations.update_demo_confirm_text",
                )}
              </div>
            </div>
          </div>
        );
      }

      const actionTexts = {
        0: t("modeling_inputs_v2.batch_operations.recalculate"),
        1: t("modeling_inputs_v2.batch_operations.reset_modeling"),
        2:
          reprocessMode === "broadcast"
            ? t("modeling_inputs_v2.batch_operations.broadcast_label")
            : reprocessMode === "multi_month"
              ? t("modeling_inputs_v2.batch_operations.multi_month_label")
              : t("modeling_inputs_v2.batch_operations.reprocess_input"),
      };
      const actionText = actionTexts[specialOptionsTab];
      let descriptionText;
      if (specialOptionsTab === 2) {
        if (reprocessMode === "multi_month") {
          descriptionText = t(
            "modeling_inputs_v2.batch_operations.multi_month_confirm_text",
          );
        } else if (reprocessMode === "broadcast") {
          descriptionText = t(
            "modeling_inputs_v2.batch_operations.broadcast_confirm_text",
          );
        } else if (
          reprocessMode === "existing" &&
          specialOptionsSelectedInputs.length > 0
        ) {
          const hasAuto = specialOptionsSelectedInputs.some(
            (i) => i.is_auto_generated,
          );
          descriptionText = hasAuto
            ? t(
                "modeling_inputs_v2.batch_operations.reprocess_confirm_text_auto",
              )
            : t("modeling_inputs_v2.batch_operations.reprocess_confirm_text");
        } else {
          descriptionText = specialOptionsSelectedInput?.is_auto_generated
            ? t(
                "modeling_inputs_v2.batch_operations.reprocess_confirm_text_auto",
              )
            : t("modeling_inputs_v2.batch_operations.reprocess_confirm_text");
        }
      } else if (specialOptionsTab === 1) {
        descriptionText =
          specialOptionsResetMode === "hard"
            ? t("modeling_inputs_v2.batch_operations.reset_hard_confirm_text")
            : t("modeling_inputs_v2.batch_operations.reset_soft_confirm_text");
      } else {
        descriptionText = t(
          "modeling_inputs_v2.batch_operations.recalculate_confirm_text",
        );
      }

      return (
        <div style={{ padding: "16px 0" }}>
          <div
            style={{
              padding: "16px",
              backgroundColor: grayColor[19] + "66",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <div style={{ fontWeight: "500", marginBottom: "8px" }}>
              {actionText}
            </div>
            <div
              style={{
                fontSize: "14px",
                color: grayColor[0],
                marginBottom: "12px",
              }}
            >
              {descriptionText}
            </div>
            {specialOptionsTab === 2 &&
              reprocessMode === "existing" &&
              specialOptionsSelectedInputs.length > 0 && (
                <div
                  style={{
                    fontSize: "14px",
                    marginBottom: "8px",
                  }}
                >
                  <span style={{ color: grayColor[0] }}>
                    {t("modeling_inputs_v2.batch_operations.input")}
                    {specialOptionsSelectedInputs.length > 1 ? "s" : ""}:
                  </span>
                  <div
                    style={{
                      marginTop: "4px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                    }}
                  >
                    {specialOptionsSelectedInputs.map((inp) => (
                      <span
                        key={inp.input_id}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                          fontWeight: "500",
                          fontSize: "13px",
                          backgroundColor: grayColor[19] + "99",
                          padding: "2px 8px",
                          borderRadius: "12px",
                        }}
                      >
                        {inp.meta_name}
                        {inp.is_auto_generated && (
                          <Autorenew
                            style={{
                              fontSize: "12px",
                              color: "#2e7d32",
                            }}
                          />
                        )}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            {specialOptionsTab === 2 &&
              reprocessMode === "broadcast" &&
              specialOptionsSelectedInput && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    marginBottom: "8px",
                  }}
                >
                  <span style={{ color: grayColor[0] }}>
                    {t("modeling_inputs_v2.batch_operations.input")}:
                  </span>
                  <span style={{ fontWeight: "500" }}>
                    {specialOptionsSelectedInput.meta_name}
                    {specialOptionsSelectedInput.is_auto_generated && (
                      <span
                        style={{
                          marginLeft: "6px",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "3px",
                          backgroundColor: "#e8f5e9",
                          color: "#2e7d32",
                          fontSize: "11px",
                          padding: "1px 6px",
                          borderRadius: "10px",
                          fontWeight: 500,
                        }}
                      >
                        <Autorenew style={{ fontSize: "12px" }} />
                        {t(
                          "modeling_inputs_v2.batch_operations.auto_generated_badge",
                        )}
                      </span>
                    )}
                  </span>
                </div>
              )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "14px",
              }}
            >
              <span style={{ color: grayColor[0] }}>
                {t("modeling_inputs_v2.batch_operations.period")}:
              </span>
              <span style={{ fontWeight: "500" }}>
                {getSpecialOptionsRangeText()}
              </span>
            </div>
            {specialOptionsTab === 0 &&
              (userDetails?.features || []).includes("logistics_flow") && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    marginTop: "8px",
                  }}
                >
                  <span style={{ color: grayColor[0] }}>
                    {t(
                      "modeling_inputs_v2.batch_operations.recalc_logistics_label",
                    )}
                    :
                  </span>
                  <span style={{ fontWeight: "500" }}>
                    {specialOptionsRecalcLogistics
                      ? t(
                          "modeling_inputs_v2.batch_operations.recalc_logistics_yes",
                        )
                      : t(
                          "modeling_inputs_v2.batch_operations.recalc_logistics_no",
                        )}
                  </span>
                </div>
              )}
            {specialOptionsTab === 1 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "14px",
                  marginTop: "8px",
                }}
              >
                <span style={{ color: grayColor[0] }}>
                  {t("modeling_inputs_v2.batch_operations.reset_mode_label")}:
                </span>
                <span
                  style={{
                    fontWeight: "500",
                    color:
                      specialOptionsResetMode === "hard"
                        ? dangerColor[0]
                        : "inherit",
                  }}
                >
                  {specialOptionsResetMode === "hard"
                    ? t("modeling_inputs_v2.batch_operations.reset_hard_label")
                    : t("modeling_inputs_v2.batch_operations.reset_soft_label")}
                </span>
              </div>
            )}
            {specialOptionsTab === 2 &&
              reprocessMode === "broadcast" &&
              broadcastFile && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    marginTop: "8px",
                  }}
                >
                  <span style={{ color: grayColor[0] }}>
                    {t(
                      "modeling_inputs_v2.batch_operations.broadcast_file_label",
                    )}
                    :
                  </span>
                  <span style={{ fontWeight: "500" }}>
                    {broadcastFile.name}
                  </span>
                </div>
              )}
            {specialOptionsTab === 2 &&
              reprocessMode === "multi_month" &&
              specialOptionsSelectedInput && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "14px",
                      marginBottom: "8px",
                    }}
                  >
                    <span style={{ color: grayColor[0] }}>
                      {t("modeling_inputs_v2.batch_operations.input")}:
                    </span>
                    <span style={{ fontWeight: "500" }}>
                      {specialOptionsSelectedInput.meta_name}
                    </span>
                  </div>
                  <div style={{ fontSize: "14px", marginTop: "8px" }}>
                    <span style={{ color: grayColor[0] }}>
                      {t(
                        "modeling_inputs_v2.batch_operations.multi_month_files_to_upload",
                      )}
                      :
                    </span>
                    <div
                      style={{
                        marginTop: "6px",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {multiMonthAiMapping
                        .filter((i) => i.month)
                        .map((item, idx) => (
                          <div
                            key={idx}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontSize: "13px",
                              padding: "3px 0",
                              borderBottom: "1px solid " + grayColor[19],
                            }}
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                flex: 1,
                                marginRight: 12,
                              }}
                            >
                              {item.file.name}
                            </span>
                            <span style={{ fontWeight: "500", flexShrink: 0 }}>
                              {item.month.label}
                            </span>
                          </div>
                        ))}
                    </div>
                    {multiMonthAiMapping.filter((i) => !i.month).length > 0 && (
                      <div
                        style={{
                          marginTop: "8px",
                          fontSize: "12px",
                          color: grayColor[6],
                        }}
                      >
                        {multiMonthAiMapping.filter((i) => !i.month).length}{" "}
                        {t(
                          "modeling_inputs_v2.batch_operations.multi_month_unmatched_skipped",
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}
          </div>
        </div>
      );
    }

    if (specialOptionsStep === "progress") {
      if (specialOptionsTab === 4) {
        const aj = activeBatchJob;
        const fillupDone = aj?.status === "COMPLETED";
        const fillupFailed = aj?.status === "FAILED";
        const hasErr = specialOptionsError !== null;
        const fillupRunning = aj && ["PENDING", "RUNNING"].includes(aj.status);
        return (
          <div style={{ padding: "16px 0" }}>
            {hasErr && (
              <div
                style={{
                  padding: "12px",
                  backgroundColor: dangerColor[6] + "33",
                  borderLeft: `4px solid ${dangerColor[0]}`,
                  borderRadius: "4px",
                  marginBottom: "16px",
                  fontSize: "14px",
                  color: dangerColor[0],
                }}
              >
                <strong>
                  {t("modeling_inputs_v2.batch_operations.error")}:
                </strong>{" "}
                {specialOptionsError}
              </div>
            )}
            {fillupDone && !hasErr && (
              <div
                style={{
                  padding: "12px",
                  backgroundColor: successColor[6] + "33",
                  borderLeft: `4px solid ${successColor[0]}`,
                  borderRadius: "4px",
                  marginBottom: "16px",
                  fontSize: "14px",
                  color: successColor[0],
                }}
              >
                {t(
                  "modeling_inputs_v2.batch_operations.update_demo_completed_banner",
                )}
              </div>
            )}
            {fillupFailed && !hasErr && (
              <div
                style={{
                  padding: "12px",
                  backgroundColor: dangerColor[6] + "33",
                  borderRadius: "4px",
                  marginBottom: "16px",
                  fontSize: "14px",
                }}
              >
                {aj?.error_message ||
                  t("modeling_inputs_v2.batch_operations.operation_failed")}
              </div>
            )}
            <div style={{ marginBottom: "16px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    color: grayColor[0],
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {specialOptionsStatus}
                  {isPollingBatch && (
                    <ThreeDots color={grayColor[3]} height="8px" width="24px" />
                  )}
                </span>
                <span style={{ fontSize: "14px", fontWeight: "500" }}>
                  {specialOptionsProgress}%
                </span>
              </div>
              <CustomLinearProgress
                variant="determinate"
                color={
                  hasErr || fillupFailed
                    ? "danger"
                    : fillupDone
                      ? "success"
                      : "client"
                }
                value={specialOptionsProgress}
              />
            </div>
            <div
              style={{
                padding: "12px",
                backgroundColor: grayColor[19] + "66",
                borderRadius: "8px",
                fontSize: "13px",
                color: grayColor[0],
              }}
            >
              <div style={{ marginBottom: "4px" }}>
                <strong>
                  {t("modeling_inputs_v2.batch_operations.operation")}:
                </strong>{" "}
                {t("modeling_inputs_v2.batch_operations.update_demo")}
              </div>
              <div>
                <strong>
                  {t("modeling_inputs_v2.batch_operations.period")}:
                </strong>{" "}
                {t(
                  "modeling_inputs_v2.batch_operations.update_demo_period_scope",
                )}
              </div>
            </div>
            {fillupRunning && (
              <div style={{ marginTop: "16px", textAlign: "center" }}>
                <Button onClick={handleCancelBatchJob} color="danger" size="sm">
                  {t("modeling_inputs_v2.batch_operations.cancel_operation")}
                </Button>
              </div>
            )}
          </div>
        );
      }

      if (
        specialOptionsTab === 2 &&
        reprocessMode === "multi_month" &&
        multiMonthUploadProgress.staging
      ) {
        const { current, total, currentFile } = multiMonthUploadProgress;
        return (
          <div style={{ padding: "16px 0" }}>
            {specialOptionsError && (
              <div
                style={{
                  padding: "12px",
                  backgroundColor: dangerColor[6] + "33",
                  borderLeft: "4px solid " + dangerColor[0],
                  borderRadius: "4px",
                  marginBottom: "16px",
                  fontSize: "14px",
                  color: dangerColor[0],
                }}
              >
                <strong>
                  {t("modeling_inputs_v2.batch_operations.error")}:
                </strong>{" "}
                {specialOptionsError}
              </div>
            )}
            {!specialOptionsError && (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <CircularProgress size={24} />
                  <span style={{ fontSize: "14px", color: grayColor[0] }}>
                    {t(
                      "modeling_inputs_v2.batch_operations.multi_month_uploading_progress",
                      {
                        current: current,
                        total: total,
                      },
                    )}
                  </span>
                </div>
                {currentFile && (
                  <div
                    style={{
                      fontSize: "13px",
                      color: grayColor[6],
                      marginBottom: "8px",
                    }}
                  >
                    {currentFile}
                  </div>
                )}
                <CustomLinearProgress
                  variant="determinate"
                  color="client"
                  value={total > 0 ? (current / total) * 100 : 0}
                />
              </div>
            )}
          </div>
        );
      }
      const isRunning =
        activeBatchJob &&
        ["PENDING", "RUNNING"].includes(activeBatchJob.status);
      const isCompleted = activeBatchJob?.status === "COMPLETED";
      const hasError = specialOptionsError !== null;

      return (
        <div style={{ padding: "16px 0" }}>
          {hasError && (
            <div
              style={{
                padding: "12px",
                backgroundColor: dangerColor[6] + "33",
                borderLeft: `4px solid ${dangerColor[0]}`,
                borderRadius: "4px",
                marginBottom: "16px",
                fontSize: "14px",
                color: dangerColor[0],
              }}
            >
              <strong>{t("modeling_inputs_v2.batch_operations.error")}:</strong>{" "}
              {specialOptionsError}
            </div>
          )}
          {isCompleted && !hasError && (
            <div
              style={{
                padding: "12px",
                backgroundColor: successColor[6] + "33",
                borderLeft: `4px solid ${successColor[0]}`,
                borderRadius: "4px",
                marginBottom: "16px",
                fontSize: "14px",
                color: successColor[0],
              }}
            >
              {t("modeling_inputs_v2.batch_operations.completed", {
                processed: activeBatchJob?.processed_count,
                total: activeBatchJob?.total_count,
              })}
            </div>
          )}
          <div style={{ marginBottom: "16px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  color: grayColor[0],
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {specialOptionsStatus}
                {isPollingBatch && (
                  <ThreeDots color={grayColor[3]} height="8px" width="24px" />
                )}
              </span>
              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                {specialOptionsProgress}%
              </span>
            </div>
            <CustomLinearProgress
              variant="determinate"
              color={hasError ? "danger" : isCompleted ? "success" : "client"}
              value={specialOptionsProgress}
            />
          </div>
          <div
            style={{
              padding: "12px",
              backgroundColor: grayColor[19] + "66",
              borderRadius: "8px",
              fontSize: "13px",
              color: grayColor[0],
            }}
          >
            <div style={{ marginBottom: "4px" }}>
              <strong>
                {t("modeling_inputs_v2.batch_operations.operation")}:
              </strong>{" "}
              {tabLabels[specialOptionsTab]}
            </div>
            {specialOptionsTab === 2 && specialOptionsSelectedInput && (
              <div style={{ marginBottom: "4px" }}>
                <strong>
                  {t("modeling_inputs_v2.batch_operations.input")}:
                </strong>{" "}
                {specialOptionsSelectedInput.meta_name}
              </div>
            )}
            <div>
              <strong>
                {t("modeling_inputs_v2.batch_operations.period")}:
              </strong>{" "}
              {getSpecialOptionsRangeText()}
            </div>
          </div>
          {isRunning && (
            <div style={{ marginTop: "16px", textAlign: "center" }}>
              <Button onClick={handleCancelBatchJob} color="danger" size="sm">
                {t("modeling_inputs_v2.batch_operations.cancel_operation")}
              </Button>
            </div>
          )}
        </div>
      );
    }

    // Default: select step
    const descriptions = {
      0: t("modeling_inputs_v2.batch_operations.recalculate_description"),
      1: t("modeling_inputs_v2.batch_operations.reset_description"),
      2:
        reprocessMode === "broadcast"
          ? t("modeling_inputs_v2.batch_operations.broadcast_description")
          : t("modeling_inputs_v2.batch_operations.reprocess_description"),
    };
    const description = descriptions[specialOptionsTab];

    // Build input options for reprocess tab
    const reprocessInputOptions = reprocessInputsList.flatMap((group) => {
      const lang = i18n.language || "en";
      const groupLabel =
        group.group_name && typeof group.group_name === "object"
          ? group.group_name[lang] || group.group_name["en"] || ""
          : group.group_name || "";
      return group.inputs.map((inp) => {
        const inputLabel =
          inp.input_name && typeof inp.input_name === "object"
            ? inp.input_name[lang] || inp.input_name["en"] || inp.meta_name
            : inp.input_name || inp.meta_name;
        return {
          value: inp.input_id,
          label: inp.is_auto_generated
            ? `${inputLabel} (${t("modeling_inputs_v2.batch_operations.auto_generated_badge")})`
            : inputLabel,
          group: groupLabel,
          ...inp,
        };
      });
    });

    // Group options by input group
    const groupedInputOptions = [];
    const seenGroups = new Set();
    for (const opt of reprocessInputOptions) {
      if (!seenGroups.has(opt.group)) {
        seenGroups.add(opt.group);
        groupedInputOptions.push({
          label: opt.group,
          options: reprocessInputOptions.filter((o) => o.group === opt.group),
        });
      }
    }

    return (
      <div style={{ padding: "8px 0" }}>
        <div
          style={{
            fontSize: "14px",
            color: grayColor[0],
            marginBottom: "8px",
            lineHeight: "1.5",
          }}
        >
          {description}
        </div>

        {specialOptionsTab === 0 &&
          (userDetails?.features || []).includes("logistics_flow") && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                marginTop: "12px",
                marginBottom: "4px",
                userSelect: "none",
              }}
              onClick={() =>
                setSpecialOptionsRecalcLogistics(!specialOptionsRecalcLogistics)
              }
            >
              {specialOptionsRecalcLogistics ? (
                <CheckBox style={{ color: grayColor[0], fontSize: "20px" }} />
              ) : (
                <CheckBoxOutlineBlank
                  style={{ color: grayColor[0], fontSize: "20px" }}
                />
              )}
              <span
                style={{
                  marginLeft: 6,
                  fontSize: "13px",
                  color: grayColor[0],
                }}
              >
                {t(
                  "modeling_inputs_v2.batch_operations.recalc_logistics_label",
                )}
              </span>
            </div>
          )}

        {specialOptionsTab === 1 && (
          <div style={{ marginTop: "12px", marginBottom: "4px" }}>
            <div
              style={{
                display: "flex",
                gap: "16px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={() => setSpecialOptionsResetMode("soft")}
              >
                {specialOptionsResetMode === "soft" ? (
                  <RadioButtonChecked
                    style={{ color: grayColor[0], fontSize: "20px" }}
                  />
                ) : (
                  <RadioButtonUnchecked
                    style={{ color: grayColor[0], fontSize: "20px" }}
                  />
                )}
                <span
                  style={{
                    marginLeft: 4,
                    fontSize: "13px",
                    color: grayColor[0],
                  }}
                >
                  {t("modeling_inputs_v2.batch_operations.reset_soft_label")}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={() => setSpecialOptionsResetMode("hard")}
              >
                {specialOptionsResetMode === "hard" ? (
                  <RadioButtonChecked
                    style={{ color: dangerColor[0], fontSize: "20px" }}
                  />
                ) : (
                  <RadioButtonUnchecked
                    style={{ color: grayColor[0], fontSize: "20px" }}
                  />
                )}
                <span
                  style={{
                    marginLeft: 4,
                    fontSize: "13px",
                    color:
                      specialOptionsResetMode === "hard"
                        ? dangerColor[0]
                        : grayColor[0],
                  }}
                >
                  {t("modeling_inputs_v2.batch_operations.reset_hard_label")}
                </span>
              </div>
            </div>
            {specialOptionsResetMode === "hard" && (
              <div
                style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  color: dangerColor[0],
                  lineHeight: "1.4",
                }}
              >
                {t("modeling_inputs_v2.batch_operations.reset_hard_warning")}
              </div>
            )}
          </div>
        )}

        {specialOptionsTab === 2 && (
          <div style={{ marginTop: "12px", marginBottom: "4px" }}>
            <div
              style={{
                display: "flex",
                gap: "16px",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={() => {
                  setReprocessMode("existing");
                  setBroadcastFile(null);
                  setSpecialOptionsSelectedInput(null);
                }}
              >
                {reprocessMode === "existing" ? (
                  <RadioButtonChecked
                    style={{ color: grayColor[0], fontSize: "20px" }}
                  />
                ) : (
                  <RadioButtonUnchecked
                    style={{ color: grayColor[0], fontSize: "20px" }}
                  />
                )}
                <span
                  style={{
                    marginLeft: 4,
                    fontSize: "13px",
                    color: grayColor[0],
                  }}
                >
                  {t(
                    "modeling_inputs_v2.batch_operations.reprocess_existing_label",
                  )}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={() => {
                  setReprocessMode("broadcast");
                  setSpecialOptionsSelectedInput(null);
                  setSpecialOptionsSelectedInputs([]);
                  setMultiMonthFiles([]);
                  setMultiMonthAiMapping([]);
                }}
              >
                {reprocessMode === "broadcast" ? (
                  <RadioButtonChecked
                    style={{ color: grayColor[0], fontSize: "20px" }}
                  />
                ) : (
                  <RadioButtonUnchecked
                    style={{ color: grayColor[0], fontSize: "20px" }}
                  />
                )}
                <span
                  style={{
                    marginLeft: 4,
                    fontSize: "13px",
                    color: grayColor[0],
                  }}
                >
                  {t("modeling_inputs_v2.batch_operations.broadcast_label")}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={() => {
                  setReprocessMode("multi_month");
                  setSpecialOptionsSelectedInput(null);
                  setSpecialOptionsSelectedInputs([]);
                  setBroadcastFile(null);
                  setMultiMonthFiles([]);
                  setMultiMonthAiMapping([]);
                }}
              >
                {reprocessMode === "multi_month" ? (
                  <RadioButtonChecked
                    style={{ color: grayColor[0], fontSize: "20px" }}
                  />
                ) : (
                  <RadioButtonUnchecked
                    style={{ color: grayColor[0], fontSize: "20px" }}
                  />
                )}
                <span
                  style={{
                    marginLeft: 4,
                    fontSize: "13px",
                    color: grayColor[0],
                  }}
                >
                  {t("modeling_inputs_v2.batch_operations.multi_month_label")}
                </span>
              </div>
            </div>
            <div
              style={{
                marginBottom: "4px",
                fontSize: "12px",
                color: grayColor[0],
                position: "relative",
                zIndex: 1,
              }}
            >
              {t("modeling_inputs_v2.batch_operations.input")}
            </div>
            <ReactSelect
              isMulti={reprocessMode === "existing"}
              options={
                reprocessMode === "existing"
                  ? groupedInputOptions
                  : groupedInputOptions
                      .map((g) => ({
                        ...g,
                        options: g.options.filter((o) => !o.is_auto_generated),
                      }))
                      .filter((g) => g.options.length > 0)
              }
              value={
                reprocessMode === "existing"
                  ? reprocessInputOptions.filter((o) =>
                      specialOptionsSelectedInputs.some(
                        (s) => s.input_id === o.value,
                      ),
                    )
                  : specialOptionsSelectedInput
                    ? reprocessInputOptions.find(
                        (o) => o.value === specialOptionsSelectedInput.input_id,
                      )
                    : null
              }
              onChange={(selected) => {
                if (reprocessMode === "existing") {
                  const items = selected || [];
                  setSpecialOptionsSelectedInputs(
                    items.map((s) => ({
                      input_id: s.value,
                      meta_name: s.meta_name,
                      source: s.source,
                      is_auto_generated: s.is_auto_generated,
                    })),
                  );
                } else {
                  if (selected) {
                    setSpecialOptionsSelectedInput({
                      input_id: selected.value,
                      meta_name: selected.meta_name,
                      source: selected.source,
                      is_auto_generated: selected.is_auto_generated,
                    });
                  } else {
                    setSpecialOptionsSelectedInput(null);
                  }
                }
                setBroadcastFile(null);
                setMultiMonthFiles([]);
                setMultiMonthAiMapping([]);
              }}
              placeholder={t(
                "modeling_inputs_v2.batch_operations.select_input",
              )}
              isClearable
              styles={selectStyles}
              formatOptionLabel={(option) => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span>{option.label}</span>
                  {option.is_auto_generated && (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "3px",
                        backgroundColor: "#e8f5e9",
                        color: "#2e7d32",
                        fontSize: "11px",
                        padding: "1px 6px",
                        borderRadius: "10px",
                        fontWeight: 500,
                      }}
                    >
                      <Autorenew style={{ fontSize: "12px" }} />
                      {t(
                        "modeling_inputs_v2.batch_operations.auto_generated_badge",
                      )}
                    </span>
                  )}
                </div>
              )}
            />
            {reprocessMode === "broadcast" && specialOptionsSelectedInput && (
              <div style={{ marginTop: "12px" }}>
                <div
                  style={{
                    marginBottom: "4px",
                    fontSize: "12px",
                    color: grayColor[0],
                  }}
                >
                  {t(
                    "modeling_inputs_v2.batch_operations.broadcast_file_label",
                  )}
                </div>
                <input
                  ref={broadcastFileInputRef}
                  type="file"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      setBroadcastFile(e.target.files[0]);
                    }
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Button
                    size="sm"
                    color="white"
                    style={{
                      fontSize: "12px",
                      padding: "4px 12px",
                      margin: 0,
                    }}
                    onClick={() => broadcastFileInputRef.current?.click()}
                    disabled={broadcastUploading}
                  >
                    {t(
                      "modeling_inputs_v2.batch_operations.broadcast_choose_file",
                    )}
                  </Button>
                  <span
                    style={{
                      fontSize: "12px",
                      color: grayColor[0],
                    }}
                  >
                    {broadcastFile
                      ? broadcastFile.name
                      : t(
                          "modeling_inputs_v2.batch_operations.broadcast_no_file",
                        )}
                  </span>
                </div>
              </div>
            )}
            {reprocessMode === "multi_month" && specialOptionsSelectedInput && (
              <div style={{ marginTop: "12px" }}>
                <div
                  style={{
                    marginBottom: "8px",
                    fontSize: "12px",
                    color: grayColor[0],
                  }}
                >
                  {t(
                    "modeling_inputs_v2.batch_operations.multi_month_select_files",
                  )}
                </div>
                <input
                  ref={multiMonthFolderRef}
                  type="file"
                  webkitdirectory=""
                  // eslint-disable-next-line react/no-unknown-property -- directory needed with webkitdirectory for folder selection
                  directory=""
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const files = Array.from(e.target.files || []);
                    if (files.length > 0) {
                      setMultiMonthFiles((prev) => {
                        const existingNames = new Set(prev.map((f) => f.name));
                        const newFiles = files.filter(
                          (f) => !existingNames.has(f.name),
                        );
                        return [...prev, ...newFiles];
                      });
                    }
                    e.target.value = "";
                  }}
                />
                <input
                  ref={multiMonthFileRef}
                  type="file"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const files = Array.from(e.target.files || []);
                    if (files.length > 0) {
                      setMultiMonthFiles((prev) => {
                        const existingNames = new Set(prev.map((f) => f.name));
                        const newFiles = files.filter(
                          (f) => !existingNames.has(f.name),
                        );
                        return [...prev, ...newFiles];
                      });
                    }
                    e.target.value = "";
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "8px",
                  }}
                >
                  <Button
                    size="sm"
                    color="white"
                    style={{
                      fontSize: "12px",
                      padding: "4px 12px",
                      margin: 0,
                    }}
                    onClick={() => multiMonthFolderRef.current?.click()}
                  >
                    <FolderOpen style={{ fontSize: "16px", marginRight: 4 }} />
                    {t(
                      "modeling_inputs_v2.batch_operations.multi_month_select_folder",
                    )}
                  </Button>
                  <Button
                    size="sm"
                    color="white"
                    style={{
                      fontSize: "12px",
                      padding: "4px 12px",
                      margin: 0,
                    }}
                    onClick={() => multiMonthFileRef.current?.click()}
                  >
                    <InsertDriveFile
                      style={{ fontSize: "16px", marginRight: 4 }}
                    />
                    {t(
                      "modeling_inputs_v2.batch_operations.multi_month_select_files_btn",
                    )}
                  </Button>
                  {multiMonthFiles.length > 0 && (
                    <Button
                      size="sm"
                      color="white"
                      style={{
                        fontSize: "12px",
                        padding: "4px 12px",
                        margin: 0,
                        color: dangerColor[0],
                      }}
                      onClick={() => setMultiMonthFiles([])}
                    >
                      <DeleteSweep
                        style={{ fontSize: "16px", marginRight: 4 }}
                      />
                      {t(
                        "modeling_inputs_v2.batch_operations.multi_month_clear",
                      )}
                    </Button>
                  )}
                </div>
                {multiMonthFiles.length > 0 && (
                  <div
                    style={{
                      maxHeight: "180px",
                      overflowY: "auto",
                      border: "1px solid " + grayColor[11],
                      borderRadius: "6px",
                      padding: "4px 0",
                    }}
                  >
                    {multiMonthFiles.map((file, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "3px 12px",
                          fontSize: "12px",
                          color: grayColor[0],
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {file.name}
                        </span>
                        <Close
                          style={{
                            fontSize: "14px",
                            cursor: "pointer",
                            color: grayColor[6],
                            flexShrink: 0,
                            marginLeft: 8,
                          }}
                          onClick={() =>
                            setMultiMonthFiles((prev) =>
                              prev.filter((_, i) => i !== idx),
                            )
                          }
                        />
                      </div>
                    ))}
                  </div>
                )}
                {multiMonthFiles.length > 0 && (
                  <div
                    style={{
                      marginTop: "4px",
                      fontSize: "11px",
                      color: grayColor[6],
                    }}
                  >
                    {multiMonthFiles.length}{" "}
                    {multiMonthFiles.length === 1
                      ? t(
                          "modeling_inputs_v2.batch_operations.multi_month_file_count_singular",
                        )
                      : t(
                          "modeling_inputs_v2.batch_operations.multi_month_file_count_plural",
                        )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {monthRangeSelector}
        {!isValidMonthRange() &&
          specialOptionsStartMonth &&
          specialOptionsEndMonth && (
            <div
              style={{
                marginTop: "8px",
                fontSize: "12px",
                color: dangerColor[0],
              }}
            >
              O mês inicial deve ser anterior ou igual ao mês final.
            </div>
          )}
      </div>
    );
  };

  return (
    <Dialog
      classes={{
        root: classes.modalRoot,
        paper: classes.modal,
      }}
      open={specialOptionsModalOpen}
      TransitionComponent={Transition}
      onClose={handleCloseSpecialOptionsModal}
      aria-labelledby="special-options-modal-title"
      aria-describedby="special-options-modal-description"
      fullWidth
      maxWidth={"md"}
    >
      <ModalHeader
        id="special-options-modal-title"
        title={t("modeling_inputs_v2.batch_operations.special_options")}
        subtitleParts={[
          t("modeling_inputs_v2.batch_operations.recalculate"),
          t("modeling_inputs_v2.batch_operations.reset_modeling"),
          t("modeling_inputs_v2.batch_operations.reprocess_input"),
          t("modeling_inputs_v2.batch_operations.remove_lock"),
        ]}
        onClose={handleCloseSpecialOptionsModal}
        closeLabel={t("common.close")}
        clientColor={clientColor}
      />
      <DialogContent
        id="special-options-modal-description"
        className={classes.modalBody}
        style={{ paddingTop: 0 }}
      >
        {specialOptionsStep !== "progress" &&
          specialOptionsStep !== "ai_matching" && (
            <Tabs
              value={specialOptionsTab}
              onChange={(e, newValue) => {
                setSpecialOptionsTab(newValue);
                setSpecialOptionsStep("select");
                if (newValue !== 2) {
                  setSpecialOptionsSelectedInput(null);
                  setSpecialOptionsSelectedInputs([]);
                }
                setMultiMonthFiles([]);
                setMultiMonthAiMapping([]);
                setMultiMonthAiLoading(false);
                if (newValue === 3) {
                  fetchLockStatus();
                }
              }}
              variant="scrollable"
              scrollButtons="auto"
              indicatorColor="primary"
              textColor="primary"
              style={{
                borderBottom: `1px solid ${grayColor[11]}`,
                marginBottom: "8px",
                marginTop: "10px",
              }}
            >
              <Tab
                label={
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <Refresh style={{ fontSize: "18px" }} />
                    {t("modeling_inputs_v2.batch_operations.recalculate")}
                  </span>
                }
                style={{ textTransform: "none", minWidth: "auto" }}
              />
              <Tab
                label={
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <RotateLeftRounded style={{ fontSize: "18px" }} />
                    {t("modeling_inputs_v2.batch_operations.reset_modeling")}
                  </span>
                }
                style={{ textTransform: "none", minWidth: "auto" }}
              />
              <Tab
                label={
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <FindReplace style={{ fontSize: "18px" }} />
                    {t("modeling_inputs_v2.batch_operations.reprocess_input")}
                  </span>
                }
                style={{ textTransform: "none", minWidth: "auto" }}
              />
              <Tab
                label={
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <LockOpen style={{ fontSize: "18px" }} />
                    {t("modeling_inputs_v2.batch_operations.remove_lock")}
                  </span>
                }
                style={{ textTransform: "none", minWidth: "auto" }}
              />
              {showUpdateDemoTab && (
                <Tab
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <CloudUpload style={{ fontSize: "18px" }} />
                      {t("modeling_inputs_v2.batch_operations.update_demo")}
                    </span>
                  }
                  style={{ textTransform: "none", minWidth: "auto" }}
                />
              )}
            </Tabs>
          )}
        {renderTabContent()}
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        {specialOptionsStep === "select" && (
          <>
            <Button
              onClick={handleCloseSpecialOptionsModal}
              color="black"
              simple
            >
              {t("modeling_inputs_v2.batch_operations.close")}
            </Button>
            {specialOptionsTab !== 3 && (
              <Button
                onClick={handleSpecialOptionsConfirm}
                color="client"
                simple
                disabled={!isValidSpecialOptionsSelection()}
              >
                {t("modeling_inputs_v2.batch_operations.continue")}
              </Button>
            )}
          </>
        )}
        {specialOptionsStep === "ai_matching" && (
          <>
            <Button onClick={handleSpecialOptionsBack} color="black" simple>
              {t("modeling_inputs_v2.batch_operations.back")}
            </Button>
            {!multiMonthAiLoading &&
              multiMonthAiMapping.filter((i) => i.month).length > 0 && (
                <Button
                  onClick={handleMultiMonthConfirmMapping}
                  color="client"
                  simple
                >
                  {t("modeling_inputs_v2.batch_operations.continue")}
                </Button>
              )}
          </>
        )}
        {specialOptionsStep === "confirm" && (
          <>
            <Button onClick={handleSpecialOptionsBack} color="black" simple>
              {t("modeling_inputs_v2.batch_operations.back")}
            </Button>
            <Button
              onClick={
                specialOptionsTab === 2 && reprocessMode === "multi_month"
                  ? handleMultiMonthExecute
                  : handleSpecialOptionsExecute
              }
              color={
                specialOptionsTab === 0 || specialOptionsTab === 4
                  ? "client"
                  : "danger"
              }
              simple
            >
              {t("modeling_inputs_v2.batch_operations.proceed")}
            </Button>
          </>
        )}
        {specialOptionsStep === "progress" && (
          <Button onClick={handleCloseSpecialOptionsModal} color="black" simple>
            {t("modeling_inputs_v2.batch_operations.close")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
